import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { enableProdMode } from '@angular/core'

import { environment } from './environments/environment'
import { AppModule } from './app/app.module'

//! B-053 · Este bloque viene en la plantilla de `ng new` y en este repo nunca se puso: `enableProdMode`
//! no aparecía en NINGÚN archivo. El paquete desplegado corría en modo desarrollo para todos los
//! usuarios de producción, lo que significa que Angular ejecuta CADA ciclo de detección de cambios
//! DOS veces —la comprobación de expresiones que cambiaron después de comprobarse— además de dejar
//! activas las verificaciones de desarrollo y de imprimir el aviso en la consola de cada usuario.
//!
//* QA se sigue construyendo con la configuración `development`, así que allí el modo desarrollo
//* permanece a propósito: esas comprobaciones extra son justo lo que conviene que salte al probar.
if (environment.production) enableProdMode()

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
